import React from 'react';
import './style.sass';
const BannerFillWidth = ({ banner, alt, customClass = '' }) => {
    return (
        <div className={`fullwidth-container ${customClass}`}>
            <img src={banner} alt={alt} className="fullwidth-container__banner" />
        </div>
    );
};

export default BannerFillWidth;
